/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker header styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';
import { DatePickerCellStyled, DatePickerCellWrapperStyled } from '../DatePickerStyled';

/*
* -------------------------------------------
*           Container style
* -------------------------------------------
*/
export const DatePickerHeaderStyled = styled.div.attrs({
    className: 'date-picker__header',
})`

`;

/*
* -------------------------------------------
*           Selector style
* -------------------------------------------
*/

interface IDatePickerHeaderSelectorArrowStyled {
    icon: string;
    isDisabled: boolean;
    side: 'left' | 'right';
}

export const DatePickerHeaderSelectorStyled = styled.div.attrs({
    className: 'date-picker__selector',
})`
    display: flex;
    width: 100%;
`;

export const DatePickerHeaderSelectorArrowStyled = styled.div.attrs((props: IDatePickerHeaderSelectorArrowStyled) => ({
    'className': [
        'date-picker__selector-arrow',
        `${props.isDisabled ? ' disabled' : ''}`,
        `${props.side === 'left' ? ' arrow_left' : ' arrow_right'}`,
    ].join(''),
    'data-selector-arrow': `${props.side === 'left' ? 'selectArrowLeft' : 'selectArrowRight'}`,
}))<IDatePickerHeaderSelectorArrowStyled>`
    flex-basis: 20px;
    object-fit: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    background-image: url(${props => props.icon});

    &.disabled {
        pointer-events: none;
        opacity: 0.2;
    }

    &.arrow_right {
        transform: rotate(180deg);
    }
`

/*
* -------------------------------------------
*           Weeks style
* -------------------------------------------
*/

export const DatePickerHeaderWeekStyled = styled(DatePickerCellWrapperStyled)`
    margin-top: 12px;
`;


export const DatePickerHeaderWeekCellStyled = styled(DatePickerCellStyled).attrs({
    className: 'date-picker__header-week-cell',
})`
    ${fonts.textHeader5};
`;

/*
* -------------------------------------------
*           Line style
* -------------------------------------------
*/

export const DatePickerHeaderLineStyled = styled.div.attrs({
    className: 'date-picker__header-line',
})`
    width: 100%;
    margin: 8px 0;
    border-bottom: 1px solid ${colors.backgroundColorHoverOpacity};
`;

